// Vendor libraries
import { ElementRef, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
// Interfaces / Types / Enums
import { QuillToolbarFormatType, BASE_TOOLBAR_FORMATS } from './constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = ["quillEditorContainer"];
const _c1 = ["quillToolbarContainer"];
function TextEditComponent_div_1_ng_container_2_select_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "select", 13);
    i0.ɵɵelement(1, "option", 14)(2, "option", 15)(3, "option", 16)(4, "option", 17);
    i0.ɵɵelementEnd();
} }
function TextEditComponent_div_1_ng_container_2_button_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 18);
} }
function TextEditComponent_div_1_ng_container_2_button_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 19);
} }
function TextEditComponent_div_1_ng_container_2_button_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 20);
} }
function TextEditComponent_div_1_ng_container_2_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function TextEditComponent_div_1_ng_container_2_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.addDynamicDate()); });
    i0.ɵɵelementEnd();
} }
function TextEditComponent_div_1_ng_container_2_button_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 22);
} }
function TextEditComponent_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "container-element", 6);
    i0.ɵɵtemplate(2, TextEditComponent_div_1_ng_container_2_select_2_Template, 5, 0, "select", 7)(3, TextEditComponent_div_1_ng_container_2_button_3_Template, 1, 0, "button", 8)(4, TextEditComponent_div_1_ng_container_2_button_4_Template, 1, 0, "button", 9)(5, TextEditComponent_div_1_ng_container_2_button_5_Template, 1, 0, "button", 10)(6, TextEditComponent_div_1_ng_container_2_button_6_Template, 1, 0, "button", 11)(7, TextEditComponent_div_1_ng_container_2_button_7_Template, 1, 0, "button", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const format_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", format_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.SIZE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.BOLD);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.ITALIC);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.UNDERLINE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.DATE_EMBED);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.LINK);
} }
function TextEditComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 1);
    i0.ɵɵtemplate(2, TextEditComponent_div_1_ng_container_2_Template, 8, 7, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.formats);
} }
/**
 *
 * Text Edit Component
 *
 * Allows text edition with a WYSIWYG editor. Text is saved as HTML. To be used in text edit modals.
 *
 *
 * Input Properties:
 *  text: HTML string that will be edited.
 *  extraFormats: A list of quill js toolbar editor formats
 *  customScrollContainerStyles: custom styles for the quillScrollContainer element
 *  readOnly: make quill editable or not
 *  disableLineBreaks: prevent line breaks from being added to the text
 *
 * Output Properties:
 *  textChanged: EventEmitter that emits when text is changed (as HTML string).
 *
 */
export class TextEditComponent {
    constructor() {
        this.extraFormats = [];
        this.readOnly = false;
        this.customScrollContainerStyles = {};
        this.disableLineBreaks = false;
        this.textChanged = new EventEmitter();
        this.quillEditor = null;
        this.defaultScrollContainerStyles = {
            'height': '350px',
            'max-height': '350px',
            'max-width': '582px',
            'overflow-y': 'auto',
        };
        this.scrollContainerStyles = {};
        this.formats = [];
        this.TOOLBAR_TYPES = QuillToolbarFormatType;
    }
    ngOnInit() {
        this.scrollContainerStyles = { ...this.defaultScrollContainerStyles, ...this.customScrollContainerStyles };
        this.formats = [...this.extraFormats, ...BASE_TOOLBAR_FORMATS];
    }
    async ngAfterViewInit() {
        const Quill = (await import('quill')).default;
        if (this.formats.includes(QuillToolbarFormatType.DATE_EMBED)) {
            const Embed = Quill.import('blots/embed');
            class SpanEmbed extends Embed {
                static create(value) {
                    const node = super.create(value);
                    node.style = 'font-style: italic; color: rgb(102, 102, 102);';
                    node.innerText = value;
                    return node;
                }
            }
            SpanEmbed.blotName = 'dateEmbed';
            SpanEmbed.tagName = 'dateEmbed';
            Quill.register(SpanEmbed);
        }
        const quillOptions = {
            modules: {
                toolbar: this.readOnly ? false : { container: this.quillToolbarContainer.nativeElement },
            },
            formats: this.formats,
            theme: 'snow',
            bounds: this.quillEditorContainer.nativeElement,
            readOnly: this.readOnly,
        };
        if (this.disableLineBreaks) {
            quillOptions.modules.keyboard = {
                bindings: {
                    enter: {
                        key: 13,
                        handler: () => {
                            return false;
                        },
                    },
                },
            };
            // Wrap the text in a paragraph tag so that it is displayed correctly in the Quill Editor
            if (!this.text.startsWith('<p>') && !this.text.endsWith('</p>')) {
                this.text = `<p>${this.text}</p>`;
            }
        }
        this.quillEditor = new Quill(this.quillEditorContainer.nativeElement, quillOptions);
        this.quillEditor.clipboard.addMatcher(Node.ELEMENT_NODE, function (node) {
            const plaintext = node.innerText;
            const Delta = Quill.import('delta');
            return new Delta().insert(plaintext);
        });
        this.quillEditor.on('text-change', () => {
            const newText = this.quillEditor?.root.innerHTML;
            const today = formatDate(new Date(), 'M/d/yyyy', 'en-US', 'UTC');
            // Removing the contenteditable span since a new one gets added every time the quill editor is opened
            const pattern = /<dateEmbed style="font-style: italic; color: rgb\(102, 102, 102\);">(.+?)<span contenteditable="false">(.+?)<\/span>(.+?)<\/dateEmbed>/g;
            const replacement = `<dateEmbed style="font-style: italic; color: rgb(102, 102, 102);">${today}</dateEmbed>`;
            const outputString = newText?.replace(pattern, replacement);
            this.textChanged.emit(outputString);
        });
        // We are using `this.quillEditor.root.innerHTML` instead of Quill API (with something like
        // `this.quillEditor.clipboard.dangerouslyPasteHTML(this.text)`) because it does not work as expected: For some
        // reason, the method gets rid of line breaks, changing the saved HTML just because.
        this.setText(this.text);
    }
    setText(text) {
        if (this.quillEditor) {
            this.quillEditor.root.innerHTML = text;
        }
    }
    addDynamicDate() {
        const selection = this.quillEditor?.getSelection(true);
        const today = formatDate(new Date(), 'M/d/yyyy', 'en-US', 'UTC');
        if (this.quillEditor) {
            this.quillEditor.insertEmbed(selection.index, 'dateEmbed', today);
            this.quillEditor.setSelection(selection.index + 1, 0);
        }
    }
}
TextEditComponent.ɵfac = function TextEditComponent_Factory(t) { return new (t || TextEditComponent)(); };
TextEditComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TextEditComponent, selectors: [["ycn-text-edit"]], viewQuery: function TextEditComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.quillEditorContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.quillToolbarContainer = _t.first);
    } }, inputs: { text: "text", extraFormats: "extraFormats", readOnly: "readOnly", customScrollContainerStyles: "customScrollContainerStyles", disableLineBreaks: "disableLineBreaks" }, outputs: { textChanged: "textChanged" }, decls: 5, vars: 2, consts: [["quillEditorContainer", ""], ["quillToolbarContainer", ""], ["href", i0.ɵɵtrustConstantResourceUrl `https://cdn.quilljs.com/1.3.6/quill.snow.css`, "rel", "stylesheet"], [4, "ngIf"], [3, "ngStyle"], [4, "ngFor", "ngForOf"], [3, "ngSwitch"], ["class", "ql-size", 4, "ngSwitchCase"], ["class", "ql-bold", 4, "ngSwitchCase"], ["class", "ql-italic", 4, "ngSwitchCase"], ["class", "ql-underline", 4, "ngSwitchCase"], ["class", "ql-addDate", 3, "click", 4, "ngSwitchCase"], ["class", "ql-link", 4, "ngSwitchCase"], [1, "ql-size"], ["value", "small"], ["selected", ""], ["value", "large"], ["value", "huge"], [1, "ql-bold"], [1, "ql-italic"], [1, "ql-underline"], [1, "ql-addDate", 3, "click"], [1, "ql-link"]], template: function TextEditComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "link", 2);
        i0.ɵɵtemplate(1, TextEditComponent_div_1_Template, 3, 1, "div", 3);
        i0.ɵɵelementStart(2, "div", 4);
        i0.ɵɵelement(3, "div", null, 0);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngStyle", ctx.scrollContainerStyles);
    } }, dependencies: [i1.NgForOf, i1.NgIf, i1.NgStyle, i1.NgSwitch, i1.NgSwitchCase], encapsulation: 2 });
